import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";
import * as AOS from 'aos';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

    // Animation framework
    AOS.init({
      
    });


  }

}
